import { useScrollReveal } from '../../../hooks/useScrollReveal';

interface CTASectionProps {
  onBookCall: () => void;
}

const trust = [
  { icon: "ri-shield-check-line", label: "No contracts required" },
  { icon: "ri-timer-flash-line", label: "Live in weeks, not months" },
  { icon: "ri-customer-service-2-line", label: "Dedicated system support" },
];

const CTASection = ({ onBookCall }: CTASectionProps) => {
  const { ref: contentRef, visible: contentVisible } = useScrollReveal();

  return (
    <section className="relative bg-[#1d1d1f] py-40 overflow-hidden text-center">
      {/* Subtle background glow */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-sapphire/10 rounded-full blur-[120px]"></div>
      </div>

      <div
        ref={contentRef}
        className={`reveal-el ${contentVisible ? 'is-visible' : ''} relative z-10 max-w-4xl mx-auto px-6`}
      >
        <p className="text-sapphire text-xs font-bold uppercase tracking-widest mb-8">Ready to Scale</p>
        <h2 className="text-6xl lg:text-7xl xl:text-8xl font-black text-white leading-[1.0] tracking-tight mb-8">
          Let's Build<br />Your System
        </h2>
        <p className="text-white/40 text-xl max-w-xl mx-auto mb-14 leading-relaxed">
          Stop losing revenue to gaps in your operations. We'll design and deploy the exact system your business needs.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={onBookCall}
            className="bg-white hover:bg-white/90 text-[#1d1d1f] text-sm font-bold px-10 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            Book a Strategy Call
          </button>
          <a
            href="/services"
            className="border border-white/20 hover:border-white/50 text-white text-sm font-semibold px-10 py-4 rounded-full transition-all cursor-pointer whitespace-nowrap w-full sm:w-auto text-center"
          >
            View Our Services
          </a>
        </div>

        {/* Trust indicators */}
        <div className="flex flex-wrap items-center justify-center gap-8 mt-16 pt-12 border-t border-white/10">
          {trust.map((t) => (
            <div key={t.label} className="flex items-center gap-2.5">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${t.icon} text-sapphire text-sm`}></i>
              </span>
              <span className="text-xs text-white/50 font-medium">{t.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
